var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { summaries } from '../../../helper/util';
import { Component, Prop } from 'vue-property-decorator';
var DetailTable = (function (_super) {
    __extends(DetailTable, _super);
    function DetailTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 435;
        return _this;
    }
    DetailTable.prototype.getIsShowArrivedate = function () {
        if (this.statementModel !== 3) {
            if (this.statementModel === 1) {
                if (this.hasRkBill.other_order_items_has_rk_bill == 1) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (this.statementModel === 2) {
                if (this.hasRkBill.order_list_has_rk_bill == 1) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        else {
            return false;
        }
    };
    DetailTable.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = [
            'money',
            'money_settlement_currency',
            'order_tax_money',
            'order_tax_money_settlement_currency',
            'order_money',
            'order_money_settlement_currency',
            'order_document_money',
            'order_document_tax_money',
            'un_order_document_money',
            'order_detail_money',
            'order_detail_money_settlement_currency',
            'order_detail_tax_money',
            'order_detail_tax_money_settlement_currency',
            'order_detail_total_money',
            'order_detail_total_money_settlement_currency',
        ];
        var moneyFields = ['money', 'order_tax_money', 'order_money', 'order_detail_money', 'order_detail_tax_money', 'order_detail_total_money', 'order_document_money', 'order_document_tax_money', 'un_order_document_money'];
        var processedData = param.data.map(function (row) {
            var newRow = __assign({}, row);
            moneyFields.forEach(function (field) {
                if (row.fee_direction === 2 && row[field] !== undefined) {
                    newRow[field] = -Math.abs(row[field]);
                }
            });
            return newRow;
        });
        var processedParam = __assign({}, param, { data: processedData });
        sums = summaries(processedParam, showSum);
        sums[0] = '总计';
        return sums;
    };
    DetailTable.prototype.previewImage = function (url) {
        window.open(url);
    };
    DetailTable.prototype.toDetail = function (row) {
        this.$emit('to-detail', row);
    };
    __decorate([
        Prop({
            required: false,
            type: Object,
            default: {
                other_order_items_has_rk_bill: 0,
                order_list_has_rk_bill: 0
            },
        })
    ], DetailTable.prototype, "hasRkBill", void 0);
    __decorate([
        Prop({
            required: true,
            type: Array,
        })
    ], DetailTable.prototype, "tableData", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number,
            default: 1,
        })
    ], DetailTable.prototype, "orderId", void 0);
    __decorate([
        Prop({
            required: true,
            type: Boolean,
        })
    ], DetailTable.prototype, "isShowPrePayment", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number,
            default: 1,
        })
    ], DetailTable.prototype, "statementModel", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number,
            default: 1,
        })
    ], DetailTable.prototype, "businessType", void 0);
    __decorate([
        Prop({
            required: true,
            type: Object,
            default: function () { return ({}); },
        })
    ], DetailTable.prototype, "propKeys", void 0);
    __decorate([
        Prop({
            required: true,
            type: String,
            default: '',
        })
    ], DetailTable.prototype, "templateId", void 0);
    __decorate([
        Prop({
            required: false,
            type: [String, Number],
            default: '',
        })
    ], DetailTable.prototype, "businessId", void 0);
    __decorate([
        Prop({
            required: false,
            type: Boolean,
            default: false,
        })
    ], DetailTable.prototype, "isOpenMultiCurrency", void 0);
    DetailTable = __decorate([
        Component({})
    ], DetailTable);
    return DetailTable;
}(Vue));
export default DetailTable;
